/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CatalogItemId} from "./catalogItemId.zod";
import {RealtimeResourceChange} from "./realtimeResourceChange.zod";

export const ServiceRealtimeChange = RealtimeResourceChange.and(
  zod.object({
    resource: zod.enum(["engineering.services"]),
    resourceId: CatalogItemId,
    change: zod.enum(["CREATED", "UPDATED", "DELETED", "RESTORED"]),
  }),
);

export type ServiceRealtimeChange = zod.input<typeof ServiceRealtimeChange>;
export type ServiceRealtimeChangeOutput = zod.output<typeof ServiceRealtimeChange>;
